import React from "react";
import "./Banner.css"


const Banner = () => {
  return (
    <section className="about-banner">
        <div className="banner-img">
      <img
        src="/assets/About_us/banner.png"
        alt="About Us Banner"
        
      />
</div>
     
    </section>
  );
};

export default Banner;
